var _defs, _path, _path2, _path3, _polygon, _path4, _path5, _path6, _polygon2, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect, _path14, _path15, _path16, _path17, _path18, _path19, _rect2, _polygon3, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _polygon4, _path33;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlue2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 74 122.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#e58c88;stroke-linecap:round;stroke-linejoin:round;stroke-width:.36px;}.cls-1,.cls-2,.cls-3{fill:none;}.cls-2,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22{stroke-width:0px;}.cls-4{fill:url(#linear-gradient);}.cls-5{fill:url(#linear-gradient-10);}.cls-3{stroke:#a1d68a;stroke-miterlimit:10;}.cls-6{fill:url(#linear-gradient-4);}.cls-7{fill:url(#linear-gradient-2);}.cls-8{fill:url(#linear-gradient-3);}.cls-9{fill:url(#linear-gradient-8);}.cls-10{fill:url(#linear-gradient-9);}.cls-11{fill:url(#linear-gradient-7);}.cls-12{fill:url(#linear-gradient-5);}.cls-13{fill:url(#linear-gradient-6);}.cls-14{fill:#759e5f;}.cls-15{fill:#79baff;}.cls-16{fill:#2a2a41;}.cls-17{fill:#a1d68a;}.cls-18{fill:#121413;}.cls-19{fill:#d4caa2;}.cls-20{fill:#bbb290;}.cls-21{fill:#89ba75;}.cls-22{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 3816.61,
    y1: 3222.6,
    x2: 3825.09,
    y2: 3222.6,
    gradientTransform: "translate(4049.37 2949.7) rotate(-103.89) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf8786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#cd9a95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#ddb1a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#eac2b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#f3cec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#f8d6c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fad8c8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 3822.53,
    y1: 3222.68,
    x2: 3824.54,
    y2: 3222.74,
    gradientTransform: "translate(4049.37 2949.7) rotate(-103.89) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf8786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#c28b8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#d6a7a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#e6bdb2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f1ccbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#f7d5c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fad8c8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 2601.54,
    y1: -1690.62,
    x2: 2610.01,
    y2: -1690.62,
    gradientTransform: "translate(1085.88 2949.7) rotate(-76.11)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 2607.46,
    y1: -1690.54,
    x2: 2609.47,
    y2: -1690.49,
    gradientTransform: "translate(1085.88 2949.7) rotate(-76.11)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 38.53,
    y1: 29.03,
    x2: 38.53,
    y2: 40.74,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 53.93,
    y1: 11.29,
    x2: 53.62,
    y2: 20.79,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 23.92,
    y1: 11.4,
    x2: 24.31,
    y2: 21.08,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 38.83,
    y1: 10.68,
    x2: 38.83,
    y2: 29.24,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 38.8,
    y1: 20.24,
    x2: 38.76,
    y2: 22.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fad8c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#bf8786"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 5147.35,
    y1: 30.96,
    x2: 5146.81,
    y2: 6.82,
    gradientTransform: "translate(5184.35) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#464479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#3d3b67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#343356"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#2e2e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2a2a42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a2a41"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m18.14,109.96l7.27-.26,1.24-19.37c.17-2.63-1.97-4.84-4.61-4.75h0c-2.44.09-4.35,2.11-4.3,4.55l.41,19.82Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m27.75,76.25l-8.79,10.54c-1.74,2.08-1.43,5.18.67,6.89h0c1.94,1.57,4.75,1.41,6.51-.36l9.7-9.81c2.02-2.04,1.84-5.38-.4-7.19l-.9-.73c-2.06-1.67-5.08-1.37-6.78.66Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m27.67,71.52h22.25v5.21c0,3.04-2.47,5.51-5.51,5.51h-11.24c-3.04,0-5.51-2.47-5.51-5.51v-5.21h0Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "6.61 16.91 6.24 15.44 6.77 14.53 6.25 10.88 5.87 9.36 4.28 9.75 4.39 10.44 3.13 10.62 2.05 10.87 1.07 11.21 1.12 11.42 1.02 11.02 0 11.2 .1 12.03 0 12.8 1.1 16.07 2.18 16.71 2.67 18.88 6.83 17.85 6.61 16.91"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m5.5,11.37l-1.25-.12s-.03,0-.04.01l-.68.58s-.05.02-.06,0l-.39-.29s-.03-.01-.05,0l-.43.18-.43.18s-.01,0-.02,0l-.53-.02s-.02,0-.03.01l-.95.76,1.04-.62s.02,0,.03,0l.48.05s.02,0,.03,0l.35-.22s0,0,.01,0l.39-.13s.03,0,.04,0l.46.28s.04.01.06,0l.7-.61s.02-.01.03-.01l1.23-.02Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m10.34,37.54h0c1.76-.65,2.67-2.6,2.03-4.36l-5.36-16.52-4.94,1.55,3.79,16.89c.45,2,2.56,3.15,4.48,2.44Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m6.11,32.96h0c.71-1.72,2.61-2.61,4.38-2.05l17.43,5.51c2.67.84,4.04,3.79,2.98,6.37h0c-1.04,2.52-3.97,3.67-6.44,2.51l-16.56-7.74c-1.73-.81-2.52-2.83-1.79-4.6Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "67.39 16.91 67.75 15.44 67.23 14.53 67.75 10.88 68.13 9.36 69.72 9.75 69.61 10.44 70.87 10.62 71.94 10.87 72.93 11.21 72.88 11.42 72.98 11.02 74 11.2 73.9 12.03 73.99 12.8 72.9 16.07 71.81 16.71 71.33 18.88 67.17 17.85 67.39 16.91"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m68.5,11.37l1.25-.12s.03,0,.04.01l.68.58s.05.02.06,0l.39-.29s.03-.01.05,0l.43.18.43.18s.01,0,.02,0l.53-.02s.02,0,.03.01l.95.76-1.04-.62s-.02,0-.03,0l-.48.05s-.02,0-.03,0l-.35-.22s0,0-.01,0l-.39-.13s-.03,0-.04,0l-.46.28s-.04.01-.06,0l-.7-.61s-.02-.01-.03-.01l-1.23-.02Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m63.66,37.54h0c-1.76-.65-2.67-2.6-2.03-4.36l5.36-16.52,4.94,1.55-3.79,16.89c-.45,2-2.56,3.15-4.48,2.44Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m67.89,33.3h0c-.71-1.72-2.61-2.61-4.38-2.05l-17.43,5.51c-2.67.84-4.04,3.79-2.98,6.37h0c1.04,2.52,3.97,3.67,6.44,2.51l16.56-7.74c1.73-.81,2.52-2.83,1.79-4.6Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m22.18,107.93c1.2-.04,2.21.91,2.22,2.12.01,1.66.05,3.87.15,5.27.16,2.24.2,5.57.2,5.57,0,0-11.61,1.41-14.1,1.12,0,0-.04-4.59,4.53-5.12,4.57-.53,5.44-.32,5.44-.32l-.5-6.34c-.1-1.21.84-2.26,2.06-2.31h0Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m24.71,116.9c-1.26,1.02-1.83,2.42-2.09,3.43-.08.3-.12.56-.16.77,1.41-.16,2.36-.27,2.36-.27,0,0,0-.25-.01-.67-.01-.75-.04-2.01-.1-3.26Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m21.81,117.6l-.2-5.67-1.35.05.36,4.6s-.88-.22-5.44.32c-.43.05-.82.14-1.17.25l.93,1.04c2.83-1.48,6.87-.58,6.87-.58Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m22.59,120.39c-3.37.24-9.18.61-9.18.61-.11-1.56-.54-2.44-1-2.93-1.74,1.53-1.72,3.95-1.72,3.95,1.78.2,8.21-.46,11.74-.85,1.41-.16,2.36-.27,2.36-.27,0,0,0-.25-.01-.67-.33.03-1.14.09-2.19.17Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 16.76,
    y: 107.65,
    width: 9.01,
    height: 3.84
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m59.65,109.45l-7.27-.26-1.24-19.37c-.17-2.63,1.97-4.84,4.61-4.75h0c2.44.09,4.35,2.11,4.3,4.55l-.41,19.82Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m50.03,75.74l8.79,10.54c1.74,2.08,1.43,5.18-.67,6.89h0c-1.94,1.57-4.75,1.41-6.51-.36l-9.7-9.81c-2.02-2.04-1.84-5.38.4-7.19l.9-.73c2.06-1.67,5.08-1.37,6.78.66Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m55.6,107.42c-1.2-.04-2.21.91-2.22,2.12-.01,1.66-.05,3.87-.15,5.27-.16,2.24-.2,5.57-.2,5.57,0,0,11.61,1.41,14.1,1.12,0,0,.04-4.59-4.53-5.12-4.57-.53-5.44-.32-5.44-.32l.5-6.34c.1-1.21-.84-2.26-2.06-2.31h0Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m53.07,116.39c1.26,1.02,1.83,2.42,2.09,3.43.08.3.12.56.16.77-1.41-.16-2.36-.27-2.36-.27,0,0,0-.25.01-.67.01-.75.04-2.01.1-3.26Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m55.97,117.1l.2-5.67,1.35.05-.36,4.6s.88-.22,5.44.32c.43.05.82.14,1.17.25l-.93,1.04c-2.83-1.48-6.87-.58-6.87-.58Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m55.19,119.88c3.37.24,9.18.61,9.18.61.11-1.56.54-2.44,1-2.93,1.74,1.53,1.72,3.95,1.72,3.95-1.78.2-8.21-.46-11.74-.85-1.41-.16-2.36-.27-2.36-.27,0,0,0-.25.01-.67.33.03,1.14.09,2.19.17Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 52.01,
    y: 107.14,
    width: 9.01,
    height: 3.84,
    transform: "translate(113.03 218.12) rotate(-180)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "42.2 37.73 34.87 37.73 35.89 27.76 41.18 27.76 42.2 37.73"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m54.85,39.33c.13-1.29-.43-2.62-1.56-3.25-.37-.2-.78-.34-1.21-.39l-10.2-1.24s-.24,2.2-3.35,2.2-3.35-2.2-3.35-2.2l-10.2,1.24c-.44.05-.85.19-1.21.39-1.14.63-1.7,1.96-1.56,3.26l3.98,36.53h24.87l3.79-36.54Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m52.32,10.62l3.41-.41c.12-.03.23.06.24.18l-.24,7.27c0,.08-.03.15-.1.19l-1.6.93c-.05.03-.11.04-.17.02l-2.03-.72c-.08-.03-.14-.11-.13-.2l.46-7.08c0-.09.07-.16.16-.18Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m25.58,10.73l-3.41-.41c-.12-.03-.23.06-.24.18l.24,7.27c0,.08.03.15.1.19l1.6.93c.05.03.11.04.17.02l2.03-.72c.08-.03.14-.11.13-.2l-.46-7.08c0-.09-.07-.16-.16-.18Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m38.83,7.89h-12.51c-.85,0-1.53.69-1.53,1.53v9.54c0,3.06,1.71,5.86,4.42,7.26l5.87,3.03c2.35,1.21,5.15,1.21,7.5,0l5.87-3.03c2.72-1.4,4.42-4.2,4.42-7.26v-9.54c0-.85-.69-1.53-1.53-1.53h-12.51Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m45.13,15.25c1.85-.55,4.96.14,5.74.33.12-.12.18-.18.18-.18,0,0-3.8-1.01-5.93-.38-2.13.63-3.44,3.4-3.44,3.4,0,0,.04,0,.11.01.35-.66,1.56-2.66,3.33-3.19Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m37.2,19.99c.64.13,2.01.36,3.19.07.13-.03.22.12.13.22-.47.46-1.27,1.21-1.65,1.35-.42.15-1.35-.9-1.79-1.43-.08-.09,0-.23.13-.21Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m38.8,23.53s1.51.26,2.51-.91"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m28.2,35.25s4.49,13.07-3.66,25.54l.3,2.65s14.76-10.98,8.23-28.71c0,0-4.25.2-4.87.51Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m49.53,35.25s-5.06,13.14,3.09,25.61l-.27,2.6s-14.22-11-7.69-28.73c0,0,4.25.2,4.87.51Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m54.31,5.68c-.04-1.79-2.08-2.91-3.85-3.24l-13.32-2.44-4.17.27-8.48,2.7c-1.34.43-2.27,1.66-2.31,3.07v.3c-.01.08,0,.16.02.24,1.66,5.38-1.28,18.16-2.17,21.73-.13.54.16,1.1.68,1.3,2.85,1.09,11.72,4.28,17.8,4.38,6.05.09,12.63-2.5,14.75-3.41.42-.18.68-.59.66-1.05-.05-1.54-.07-4.53-.07-6.16,0,0,.76-2.77.44-17.69Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m38.8,77.88c-1.78.03-1.78,2.2-1.78,2.2l-.02.16h3.58l-.02-.23s.02-2.16-1.77-2.13Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m37.56,41.94h2.47c6.26,0,11.34,5.08,11.34,11.34v11.53c0,3.23-2.62,5.85-5.85,5.85h-13.44c-3.23,0-5.85-2.62-5.85-5.85v-11.53c0-6.26,5.08-11.34,11.34-11.34Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m29.64,59.15h19.3v7.52c0,.51-.42.93-.93.93h-17.45c-.51,0-.93-.42-.93-.93v-7.52h0Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "29.64 57.62 48.95 57.62 49.51 59.6 28.96 59.6 29.64 57.62"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m35.51,44s-.05-4.53,2.75-4.56,3.06,4.16,3.06,4.16l-5.8.4Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlue2);
export default __webpack_public_path__ + "static/media/blue_2.dd1e837e3835a1d52f2469a9558e8c51.svg";
export { ForwardRef as ReactComponent };